//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import portal from '~/net/portal'
import myProgress from '~/components/Myprogress'
import config from '~/config'
export default {
    head() {
        return {
            title: this.demand.name,
            meta: [{ hid: 'keywords', name: 'keywords', content: this.demand.name }, { hid: 'description', name: 'description', content: this.demand.summary }]
        }
    },
    components: {
        myProgress
    },
    data() {
        return {
            cb_disabled: false,
            demandId: '',
            show: true,
            collectionVisible: false,
            collectionStatus: true,
            loginVisible: false,
            showGoodVisible: false,
            matchedGoodVisible: false,
            contactPhoneVisible: false,
            refresh: false,
            businessBrowserUrl: config.businessBrowserUrl,
            realPhone: '',
            showHeader: false,
            total: 0,
            lastPage: false,
            good: {},
            page: {
                page: 1,
                rows: 15,
                keyword: '',
                isRecommended: false,
                demandId: 1
            },
            selection: [],
            matchOperation: {
                ids: [],
                advice: ''
            },
            columns1: [
                {
                    width: 20
                },
                {
                    type: 'selection',
                    width: 24,
                    align: 'left'
                },
                {
                    width: 47,
                    align: 'left',
                    render: (h, params) => {
                        return h('img', {
                            class: 'goodsPic',
                            attrs: {
                                src: this.$absUrl(params.row.titleImgUrl)
                            }
                        })
                    }
                },
                {
                    width: 200,
                    key: 'goodsName',
                    align: 'left',
                    render: (h, params) => {
                        return h(
                            'span',
                            {
                                class: 'texts'
                            },
                            params.row.goodsName
                        )
                    }
                },
                {
                    width: 36,
                    align: 'center',
                    key: 'recommended',
                    render: (h, params) => {
                        return h('i', {
                            class: params.row.recommended ? 'iconfont icon-diamond' : ''
                        })
                    }
                },
                {
                    width: 50,
                    key: 'matchingRate',
                    render: (h, params) => {
                        console.log(params.row.matchingRate)
                        return (
                            <Tooltip trigger="hover" placement="top" content="需求与商品契合度">
                                <myProgress percent={params.row.matchingRate}></myProgress>
                            </Tooltip>
                        )
                    }
                },
                {
                    width: 7
                },
                {
                    width: 58,
                    key: 'ownerName',
                    align: 'right',
                    render: (h, params) => {
                        return h(
                            'span',
                            {
                                class: 'texts'
                            },
                            params.row.ownerName
                        )
                    }
                },
                {
                    width: 20
                }
            ],
            columns2: [
                {
                    width: 20
                },
                {
                    width: 47,
                    align: 'left',
                    render: (h, params) => {
                        return h('img', {
                            class: 'goodsPic',
                            attrs: {
                                src: this.$absUrl(params.row.titleImgUrl)
                            }
                        })
                    }
                },
                {
                    width: 224,
                    key: 'goodsName',
                    align: 'left',
                    render: (h, params) => {
                        return h(
                            'span',
                            {
                                class: 'texts'
                            },
                            params.row.goodsName
                        )
                    }
                },
                {
                    width: 36,
                    align: 'center',
                    key: 'recommended',
                    render: (h, params) => {
                        return h('i', {
                            class: params.row.recommended ? 'iconfont icon-diamond' : ''
                        })
                    }
                },
                {
                    width: 50,
                    key: 'matchingRate',
                    render: (h, params) => {
                        return (
                            <Tooltip trigger="hover" placement="top" content="需求与商品契合度">
                                <myProgress percent={params.row.matchingRate}></myProgress>
                            </Tooltip>
                        )
                    }
                },
                {
                    width: 7
                },
                {
                    width: 58,
                    key: 'ownerName',
                    align: 'right',
                    render: (h, params) => {
                        return h(
                            'span',
                            {
                                class: 'texts'
                            },
                            params.row.ownerName
                        )
                    }
                },
                {
                    width: 20
                }
            ],
            goodsList: [],
            maxPage: 3,
            currentPage: 1
        }
    },
    async asyncData(context) {
        const [resp1, resp2, resp3] = await Promise.all([
            portal.getDetailByDemandId({
                query: {
                    demanId: context.query.id,
                    hits: !!(context.query.show == undefined || context.query.show == null)
                },
                client: context.req
            }),
            portal.judgeCollected({
                query: {
                    id: context.query.id,
                    type: '01'
                },
                client: context.req
            }),
            portal.getRequireById({
                query: {
                    id: context.query.id,
                    number: 12
                },
                client: context.req
            })
        ])
        let data1
        if (resp1.code == '0000') {
            data1 = resp1.data
        } else {
            context.error({ statusCode: resp1.statusCode, messsage: resp1.message })
        }
        const data2 = resp2.data
        return {
            demand: data1,
            collectionStatus: data2 == '01',
            recommandDemands: resp3.data || []
        }
    },
    created() {
        if (this.$route.query.id != undefined) {
            this.page.demandId = this.$route.query.id
            this.demandId = this.$route.query.id
        }
        if (this.$route.query.show != undefined) {
            this.show = false
        }
    },
    validate({ query }) {
        return !!query.id
    },
    watchQuery: ['id'],
    computed: {
        ...mapState(['user', 'identities']),
        routes() {
            return [{ name: '首页', path: '/' }, { name: '需求' }, { name: this.demand.name }]
        },
        isTechManager() {
            return this.user != null && (this.identities.length > 0 && this.identities.find(_ => _.type == '01' && _.isBind != 2))
        },
        isSelf() {
            if (this.user !== null && this.demand.userId !== null) {
                return this.user.id == this.demand.userId
            }
            return false
        },
        isValid() {
            if (this.demand.status == '02' || this.demand.status == '04') {
                return true // 发布中 & 已解决
            }
            return false
        },
        currentPageDemands() {
            return this.recommandDemands.slice((this.currentPage - 1) * 4, this.currentPage * 4)
        },
        shareFile() {
            if (this.demand.demandImageList) {
                return this.$absUrl(this.demand.demandImageList[0].fileUrl)
            } else return this.$defaultImg('04')
        }
    },
    methods: {
        // getDemandType() {
        //     if (this.demand.type == '00') {
        //         return '专利'
        //     } else if (this.demand.type == '01') {
        //         return '技术成果'
        //     } else {
        //         return '专利/技术成果'
        //     }
        // },
        getDemandType() {
            if (this.demand.type == '00') {
                return '关键技术研发'
            } else if (this.demand.type == '01') {
                return '产品升级'
            } else if (this.demand.type == '02') {
                return '技术改造'
            } else if (this.demand.type == '03') {
                return '设备改进'
            } else if (this.demand.type == '04') {
                return '技术交易'
            } else if (this.demand.type == '05') {
                return '技术咨询'
            } else if (this.demand.type == '06') {
                return '海外创新合作'
            } else if (this.demand.type == '07') {
                return '科技金融'
            }
        },
        getCooperationMode() {
            let cooperationMode = ''
            switch (this.demand.cooperationMode) {
                case '00':
                    cooperationMode = '股权投资'
                    break
                case '01':
                    cooperationMode = '技术转让'
                    break
                case '02':
                    cooperationMode = '许可使用'
                    break
                case '03':
                    cooperationMode = '合作开发'
                    break
                case '04':
                    cooperationMode = '合作兴办新企业'
                    break
                case '05':
                    cooperationMode = '其他'
                    break
            }
            return cooperationMode
        },
        getStage() {
            let stage = ''
            switch (this.demand.stage) {
                case '00':
                    stage = '实验室'
                    break
                case '01':
                    stage = '小试'
                    break
                case '02':
                    stage = '中试'
                    break
                case '03':
                    stage = '产业化'
                    break
            }
            return stage
        },
        getPublishType() {
            if (this.demand.publisherType == '0') {
                return '个人'
            } else {
                return '单位'
            }
        },
        getTags() {
            if (typeof this.demand.demandTags != 'undefined') {
                return this.demand.demandTags.join(',')
            } else return ''
        },
        getRegion() {
            if (typeof this.demand.region != 'undefined') {
                return this.demand.region.split(',')
            } else return []
        },
        newGetData() {
            this.cb_disabled = true
            this.goodsList = []
            this.selection = []
            this.matchOperation.ids = []
            this.lastPage = false
            this.page.page = 1
            this.getAssociatedGoods()
        },

        reachBottom() {
            if (this.lastPage) {
                this.$Message.info('没有更多商品了')
            } else {
                this.page.page += 1
                this.getAssociatedGoods()
            }
        },
        zixun() {
            this.$store.dispatch('CheckRealName').then(
                res => {
                    if (this.realPhone !== undefined)
                        portal
                            .getPhoneByDemandId({
                                query: {
                                    demanId: this.demand.id
                                }
                            })
                            .then(res => {
                                this.demand.phone = res.data
                                this.realPhone = res.data
                                this.contactPhoneVisible = true
                            })
                },
                err => {
                    if (err == null) {
                        this.$router.push('/login')
                    } else {
                        this.$store.commit('SET_REALNAME', true)
                    }
                }
            )
        },
        ch() {
            this.page.isRecommended = false
            this.page.keyword = ''
            this.newGetData()
        },
        getAssociatedGoods() {
            const _this = this
            portal
                .getAssociatedGoods({
                    query: this.page
                })
                .then(res => {
                    const { code, data, message } = res
                    if (code === '0000') {
                        this.total = data.total
                        if (data.total !== 0) {
                            data.rows.forEach(function(item) {
                                item._disabled = _this.selection.length === 3
                                _this.goodsList.push(item)
                            })
                        }
                        this.lastPage = data.lastPage
                        this.showGoodVisible = true
                    }
                    this.cb_disabled = false
                })
        },
        // 收藏需求  传收藏id  命名接口 demandCollection
        collectionConfirm() {
            portal
                .setCollectStatus({
                    query: {
                        id: this.demandId,
                        type: '01',
                        status: this.collectionStatus ? '00' : '01'
                    }
                })
                .then(res => {
                    const { code, message } = res
                    if (code === '0000') {
                        this.collectionVisible = false
                        this.collectionStatus = !this.collectionStatus
                        if (!this.collectionStatus) this.$Message.success('收藏成功')
                        else this.$Message.success('已取消收藏')
                    }
                })
        },

        makeMatch() {
            if (this.matchOperation.advice.length > 500) {
                this.$Message.error('撮合建议不能超过500字')
                return
            }
            portal
                .makeMatch({
                    query: {
                        demandId: this.page.demandId,
                        suggestion: this.matchOperation.advice
                    },
                    body: this.matchOperation.ids
                })
                .then(res => {
                    const { code, data, message } = res
                    if (code === '0000') {
                        this.matchedGoodVisible = false
                        this.showGoodVisible = false
                        this.$Message.success('撮合成功')
                    }
                })
        },
        more() {
            this.refresh = true
            setTimeout(() => {
                this.refresh = false
                if (this.currentPage + 1 > 3 || this.currentPage + 1 > this.recommandDemands.length / 4) {
                    this.currentPage = 1
                } else this.currentPage++
            }, 500)
        },
        collection() {
            if (this.user == null) {
                this.loginVisible = true
                return
            }
            if (this.user !== null) {
                this.collectionVisible = true
            }
        },
        show4() {
            this.matchOperation.advice = ''
            this.matchedGoodVisible = true
        },
        selectionChange(value) {
            this.selection = value
            const _this = this
            this.matchOperation.ids = []
            this.selection.forEach(function(item) {
                _this.matchOperation.ids.push(item.goodId)
            })
            if (this.selection.length === 3) {
                this.goodsList.forEach(function(item) {
                    if (item.goodId === _this.matchOperation.ids[0] || item.goodId === _this.matchOperation.ids[1] || item.goodId === _this.matchOperation.ids[2]) {
                        item._disabled = false
                        item._checked = true
                    } else {
                        item._disabled = true
                    }
                })
            } else {
                this.goodsList.forEach(function(item) {
                    item._disabled = false
                    item._checked = item.goodId === _this.matchOperation.ids[0] || item.goodId === _this.matchOperation.ids[1] || item.goodId === _this.matchOperation.ids[2]
                })
            }
        }
    }
}
